module.exports = __webpack_public_path__ + "img/c4.b74401ca.jpg";